import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./ccm-campaign-payments-payouts-header-message-button.i18n.json'));

interface Props {
  campaignId: number,
  subcampaignId: number
}

const CcmCampaignPaymentsPayoutsHeaderMessageButton = ({
  campaignId,
  subcampaignId
}: Props) => (
  <div className="ccm-campaign-payments-payouts-header-message-button">
    <ActionButton
      link={`/campaigns/ccm/${campaignId}/messages?subcampaignId=${subcampaignId}`}
    >
      {__t('ccm_campaign_payments_payouts_header_message_button.text')}
    </ActionButton>
  </div>
);

export default CcmCampaignPaymentsPayoutsHeaderMessageButton;
